import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-back-to-top-button',
    templateUrl: './back-to-top-button.component.html',
    styleUrls: ['./back-to-top-button.component.css'],
})
export class BackToTopButtonComponent implements OnInit {

    constructor(private router: Router) {
    }

    ngOnInit() {
    }
}
